/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {MigratePrivacyRequestRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {MigratePrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const migratePrivacyRequest = (request: MigratePrivacyRequestRequest, options?: CashRequestOptions) => post<MigratePrivacyRequestRequest, MigratePrivacyRequestResponse>("/2.0/cash/migrate-privacy-request", request, {...options, rejectOnError: true })